import BaseService from 'vue-core/services/BaseService';
import env from 'environment';

class SystemService
    extends BaseService {
  constructor() {
    super();
  }

  info() {
    return this.get({
      url: `${env.baseUrl}/system/info`
    });
  }

  sessions() {
    return this.get({
      url: `${env.baseUrl}/system/sessions`
    });
  }
}

const service = new SystemService();

export default service;
